var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"component justify-space-between py-1 px-4"},[_c('span',[_vm._v(_vm._s(_vm.contextObjectTypeText)+": "+_vm._s(_vm.contextObjectText))]),_c('span',[_vm._v(_vm._s(_vm.dateIntervalText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }